// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "3bfb7d4b3e6501b593f8" + ".js";
};